import axios from 'axios';
import store from '@/store/store';
import config from '@/api/config/config';

const HTTPEdition = axios.create();

// Add a request interceptor
HTTPEdition.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
  };
  const hash = store.getters['recommandation/hash'];
  if (hash) {
    request.params = { ...request.params, hash };
  }
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = config.URL_SERVEUR + request.url;
  }
  return request;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

export default HTTPEdition;
